import DeliveryService from "../DeliveryService"


const Enterprise = {
    formData(data) {
        let form = new FormData()
        for (let obj in data) {
            form.append(obj, data[obj])
        }
        return form
    },
    validate(params) {
        var queryString = Object.keys(params)
            .map(key => key + "=" + params[key])
            .join("&");
         return DeliveryService.get(`/live-commerce/validate?`+queryString)
    },
    onboarding(data) {
        return DeliveryService.post(`live-commerce/onboarding?`, data)
        
    },
    getConnectedPages(params) {
         var queryString = Object.keys(params)
            .map(key => key + "=" + params[key])
            .join("&");
         return DeliveryService.get(`/live-commerce/pages?`+queryString)
    },
    getConnectedPageDetail(page_id) {
         return DeliveryService.get(`/live-commerce/pages/`+page_id)
    }
}
export default Enterprise
